import { makeActionCreator } from '../../../../utilities'
import { InitiateIvConstants } from './initiateIv.constants'

export const getSite = makeActionCreator(InitiateIvConstants.GET_SITE, 'site')
export const setSite = makeActionCreator(InitiateIvConstants.SET_SITE, 'site')
export const setSitePNNV = makeActionCreator(InitiateIvConstants.SET_SITE_PNNV, 'sitePNNV')
export const saveSite = makeActionCreator(InitiateIvConstants.SAVE_SITE, 'site')
export const deleteSite = makeActionCreator(InitiateIvConstants.DELETE_SITE, 'site')
export const setGauge = makeActionCreator(InitiateIvConstants.SET_GAUGE, 'size')
export const getType = makeActionCreator(InitiateIvConstants.GET_TYPE, 'type')
export const setType = makeActionCreator(InitiateIvConstants.SET_TYPE, 'iVType')
export const saveType = makeActionCreator(InitiateIvConstants.SAVE_TYPE, 'type')
export const deleteType = makeActionCreator(InitiateIvConstants.DELETE_TYPE, 'type')

export const saveInitiateIv = makeActionCreator(InitiateIvConstants.SAVE_INITIATE_IV, 'data')
export const resetState = makeActionCreator(InitiateIvConstants.RESET_STATE)
export const setAddToTimeLine = makeActionCreator(InitiateIvConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const setState = makeActionCreator(InitiateIvConstants.SET_STATE, 'initiateIvState')
export const setDateTime = makeActionCreator(InitiateIvConstants.SET_DATE_TIME, 'time', 'date')
export const setAssessedBy = makeActionCreator(InitiateIvConstants.SET_ASSESSED_BY, 'assessedBy')
export const onSelectInitiateIvProcedure = makeActionCreator(InitiateIvConstants.ON_SELECT_INITIATE_IV)
export const setUpdateInputRows = makeActionCreator(InitiateIvConstants.SET_UPDATE_INPUT_ROWS, 'updateInputRows')
export const setSuccessfulAttempt = makeActionCreator(InitiateIvConstants.SET_SUCCESSFUL_ATTEMPT, 'successfulAttempt')
export const setAttempts = makeActionCreator(InitiateIvConstants.SET_ATTEMPTS, 'attempts')
export const setRolePerforming = makeActionCreator(InitiateIvConstants.SET_ROLE_PERFORMING, 'rolePerforming')
export const setInitiateIvDefaults = makeActionCreator(
  InitiateIvConstants.SET_INITIATE_IV_DEFAULTS,
  'initiateIvDefaults'
)
export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  InitiateIvConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  InitiateIvConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
